type FieldDisplayDumbProps = {
  head: string;
  val: string;
}
export function FieldDisplayDumb(props: FieldDisplayDumbProps) {
  return (
    <div className="tail-flex tail-gap-x-1">
      <p className="tail-shrink-0">
      {props.head} :
      </p>
    <p className="tail-break-words tail-w-full">
      {props.val}
    </p>
    </div>);
}